module.exports = __webpack_public_path__ + "img/info.81899a9a.svg";